import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const NuestroProceso = () => {
  const d3Container = useRef(null);

  useEffect(() => {
    if (d3Container.current) {
      const data = [
        { label: "500", value: 500 },
        { label: "1200", value: 1200 },
        { label: "2500", value: 2500 },
        { label: "5000", value: 5000 },
        { label: "10000", value: 10000 },
        { label: "18000", value: 18000 },
        { label: "25000", value: 25000 },
      ];

      const margin = { top: 20, right: 50, bottom: 30, left: 80 };
      const width = 800 - margin.left - margin.right;
      const height = 400 - margin.top - margin.bottom;

      const svg = d3
        .select(d3Container.current)
        .html("") // Clear previous graph
        .append("svg")
        .attr("width", width + margin.left + margin.right)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", `translate(${margin.left}, ${margin.top})`);

      // Scales
      const xScale = d3
        .scaleLinear()
        .domain([0, d3.max(data, (d) => d.value) + 5000]) // Add padding for visibility
        .range([0, width]);

      const yScale = d3
        .scaleBand()
        .domain(data.map((d) => d.label))
        .range([0, height])
        .padding(0.2);

      // Bars
      svg
        .selectAll(".bar")
        .data(data)
        .enter()
        .append("rect")
        .attr("class", "bar")
        .attr("y", (d) => yScale(d.label))
        .attr("width", (d) => xScale(d.value))
        .attr("height", yScale.bandwidth())
        .attr("fill", "#C9A23A");

      // Labels
      svg
        .selectAll(".label")
        .data(data)
        .enter()
        .append("text")
        .attr("class", "label")
        .attr("x", (d) => xScale(d.value) + 5) // Position text slightly outside the bar
        .attr("y", (d) => yScale(d.label) + yScale.bandwidth() / 2 + 5)
        .attr("fill", "white")
        .attr("font-size", "14px")
        .attr("text-anchor", "start")
        .text((d) => d.value);
    }
  }, []);

  return <div ref={d3Container}></div>;
};

export default NuestroProceso;
